export default __webpack_public_path__ + "static/media/plate.dc60ec42.svg";